import { render, staticRenderFns } from "./vLogout.vue?vue&type=template&id=22bc9366&scoped=true&"
import script from "./vLogout.vue?vue&type=script&lang=js&"
export * from "./vLogout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bc9366",
  null
  
)

export default component.exports